import React from 'react';
import classNames from 'classnames';

interface CardGroupProps {
	layout?: 'horizontal' | 'vertical';
	className?: string;
	children: React.ReactNode;
}

export default function CardGroup({ children, className, layout = 'horizontal' }: CardGroupProps) {
	return (
		<div
			className={classNames(
				layout === 'vertical' ? 'flex flex-col gap-4' : 'grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3',
				className,
			)}
		>
			{children}
		</div>
	);
}
